import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IPersonalBalanceHistory, defaultValue } from '../../model/personal-balance-history.model';

export const ACTION_TYPES = {
  FETCH_PERSONALBALANCEHISTORY_LIST: 'personalBalanceHistory/FETCH_PERSONALBALANCEHISTORY_LIST',
  FETCH_PERSONALBALANCEHISTORY: 'personalBalanceHistory/FETCH_PERSONALBALANCEHISTORY',
  CREATE_PERSONALBALANCEHISTORY: 'personalBalanceHistory/CREATE_PERSONALBALANCEHISTORY',
  UPDATE_PERSONALBALANCEHISTORY: 'personalBalanceHistory/UPDATE_PERSONALBALANCEHISTORY',
  DELETE_PERSONALBALANCEHISTORY: 'personalBalanceHistory/DELETE_PERSONALBALANCEHISTORY',
  RESET: 'personalBalanceHistory/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPersonalBalanceHistory>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type PersonalBalanceHistoryState = Readonly<typeof initialState>;

// Reducer

export default (state: PersonalBalanceHistoryState = initialState, action): PersonalBalanceHistoryState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PERSONALBALANCEHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_PERSONALBALANCEHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_PERSONALBALANCEHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY):
    case FAILURE(ACTION_TYPES.CREATE_PERSONALBALANCEHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_PERSONALBALANCEHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_PERSONALBALANCEHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PERSONALBALANCEHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_PERSONALBALANCEHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PERSONALBALANCEHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const apiUrl = 'api/personal-balance-histories';

// Actions

export const getEntities: ICrudGetAllAction<IPersonalBalanceHistory> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY_LIST,
    payload: axios.get<IPersonalBalanceHistory>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IPersonalBalanceHistory> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_PERSONALBALANCEHISTORY,
    payload: axios.get<IPersonalBalanceHistory>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IPersonalBalanceHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PERSONALBALANCEHISTORY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IPersonalBalanceHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PERSONALBALANCEHISTORY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IPersonalBalanceHistory> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PERSONALBALANCEHISTORY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
